<layout-container class="page-padding">
<form [formGroup]="form" (ngSubmit)="onSubmit()">
<div class="form-container">
  <div class="flex flex-col gap-24">
    <section class="flex flex-col gap-8">
      <h2>Job Status</h2>
      <div class="pt-16">
        <mat-radio-group
          formControlName="jobStatus"
          aria-label="Select an option"
          class="flex flex-col sm:flex-row flex-start-start gap-12"
          color="primary"
          data-test-id="availability-update-form-jobStatus">
          <mat-radio-button [value]="JobStatuses.ON_CONTRACT">
            On a project/contract
          </mat-radio-button>
          <mat-radio-button [value]="JobStatuses.NOT_ON_CONTRACT">
            Not on a project/contract
          </mat-radio-button>
        </mat-radio-group>
        <validation-messages
          [field]="form.controls['jobStatus']"
          [messages]="['required']"
          [texts]="{ required: 'Please check one option' }"
        ></validation-messages>
      </div>
    </section>
    <section>
      <h2>Looking for project?</h2>
      <div class="pt-16">
        <mat-radio-group
          formControlName="lookingForProject"
          aria-label="Select an option"
          class="flex flex-row flex-start-start gap-12"
          color="primary">
          <mat-radio-button value="true">Yes</mat-radio-button>
          <mat-radio-button value="false">No</mat-radio-button>
        </mat-radio-group>
        <validation-messages
          [field]="form.controls['lookingForProject']"
          [messages]="['required']"
          [texts]="{ required: 'Please check one option' }"
        ></validation-messages>
      </div>
    </section>
    <section>
      <h2>When are you available?</h2>
      <div class="flex flex-col md:flex-row gap-22 pt-16">
        <div class="flex flex-col form-group">
          <mat-label>By a specific date</mat-label>
          <div class="flex flex-row flex-start-center h-[36px]">
            <mat-checkbox formControlName="immediate">Immediately</mat-checkbox>
          </div>
        </div>
        <div class="flex flex-col form-group">
          <div class="datepicker-wrapper flex flex-col">
            <datepicker
              datetimeFormControlLabel="By a specific date"
              [max]="datesValues.maxDate"
              [min]="datesValues.minDate"
              [parentForm]="form"
              datetimeFormControlName="specificDate"
            ></datepicker>
          </div>
        </div>
        <div class="flex flex-col form-group">
          <mat-label>Notice period</mat-label>
            <ng-select
              [clearable]="false"
              [closeOnSelect]="true"
              [items]="noticePeriods"
              [multiple]="false"
              formControlName="noticePeriod"
              class="notice-period-field"
            ></ng-select>
            <validation-messages
              [field]="form.controls['noticePeriod']"
              [texts]="{ required: 'Please input correct information' }"
              [messages]="['required']"
            ></validation-messages>

        </div>
      </div>
      <validation-messages
        [field]="form"
        [messages]="['atLeastOneRequired']"
        [texts]="{ atLeastOneRequired: 'Please check at least one option' }"
      ></validation-messages>
    </section>
  </div>
  <div class="actions flex flex-col flex-center-center">
    <button mat-button
            mat-flat-button
            type="submit"
            color="primary">Confirm and update</button>
  </div>
</div>
</form>
</layout-container>
